// src/features/eventos/domain/eventoFormMapper.js

export const defaultEventoForm = {
    nombre: "",
    descripcion: "",
    fechaInicio: "",
    fechaFin: "",
    rutaDocumento: "",
    enlaces: [],
    esProvisional: false,
    transfer: "",

    agenteIds: [],

    actividades: [{ nombre: "", tipo: "", fecha: "", participanteIds: [] }],
    menus: [{ nombre: "", fecha: "", lugar: "", comensales: 0, platoIds: [], vinoIds: [] }],
    participaciones: [{ personaId: "", habitacionIds: [], actividadIds: [], menuIds: [] }],
    cacerias: [{ fecha: "", nombre: "", rutaDocumento: "", enlaces: [], tipoCaceria: "", participaciones: [] }],
};

export function mapEventoToForm(evento) {
    if (!evento) return defaultEventoForm;

    const actividades = evento.actividades || [];

    // Construye un mapa persona -> set de índices (1-based) de actividades desde participaciones
    const actividadesByPersona = new Map();
    (evento.participaciones || []).forEach((p) => {
        (p.actividades || []).forEach((a) => {
            const idx = actividades.findIndex((ac) => ac.id === a.id);
            if (idx >= 0) {
                const set = actividadesByPersona.get(p.persona?.id) || new Set();
                set.add(idx + 1);
                actividadesByPersona.set(p.persona?.id, set);
            }
        });
    });

    // Derivar participanteIds por actividad
    const participanteIdsPorActividad = actividades.map((_, idx) => {
        const actIdx1 = idx + 1;
        const personaIds = [];
        (evento.participaciones || []).forEach((p) => {
            const set = actividadesByPersona.get(p.persona?.id) || new Set();
            if (set.has(actIdx1)) personaIds.push(p.persona?.id);
        });
        return personaIds.filter((x) => x != null);
    });

    // Menús: en participaciones guardamos índices 0-based
    const menuIndexById = new Map((evento.menus || []).map((m, idx) => [m.id, idx]));

    return {
        ...evento,
        agenteIds: Array.isArray(evento.agenteIds)
            ? evento.agenteIds
            : Array.isArray(evento.agentes)
                ? evento.agentes.map((a) => a?.id).filter(Boolean)
                : [],
        esProvisional: evento.esProvisional ?? false,
        transfer: evento.transfer ?? "",

        actividades: (evento.actividades || []).map((a, idx) => ({
            ...a,
            participanteIds: participanteIdsPorActividad[idx] || [],
        })),

        menus: (evento.menus || []).map((m) => ({
            ...m,
            platoIds: (m.platos || []).map((p) => p.id),
            vinoIds: (m.vinos || []).map((v) => v.id),
        })),

        participaciones: (evento.participaciones || []).map((p) => ({
            ...p,
            personaId: p.persona?.id || "",
            habitacionIds: (p.habitaciones || []).map((h) => h.id),
            actividadIds: Array.from(actividadesByPersona.get(p.persona?.id) || []),
            menuIds: (p.menus || [])
                .map((m) => menuIndexById.get(m.id))
                .filter((i) => i !== undefined && i !== -1),
        })),

        cacerias: (evento.cacerias || []).map((c) => ({
            ...c,
            participaciones: (c.participaciones || []).map((pc) => ({
                personaId: pc.persona?.id || "",
                rolId: pc.rol?.id || "",
                arma1Id: pc.arma1?.id || "",
                arma2Id: pc.arma2?.id || "",
                secretarioId: pc.secretario?.id || "",
                cargadorId: pc.cargador?.id || "",
            })),
        })),
    };
}
